import { render } from "./IndependentClock.vue?vue&type=template&id=219ac892"
import script from "./IndependentClock.vue?vue&type=script&lang=js"
export * from "./IndependentClock.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__